import { MessageCircle } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { FAQSection, FinalCTA } from "../sections/HomeBlocks2";
import { BUSINESS } from "../data/content";

export default function FAQPage() {
  return (
    <main>
      <PageHeader
        
        lines={["Straight answers,", "no fine print."]}
        sub="The most common questions about working with a fully remote studio — answered plainly. Anything else, just message us."
      />
      <FAQSection chapter="01" />
      <section className="pb-24 text-center" data-testid="faq-cta">
        <div className="container-x">
          <Reveal>
            <p className="text-[#A0A3C2]">Didn't find your answer?</p>
            <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="faq-whatsapp-btn" className="btn btn-wa no-underline mt-4">
              <MessageCircle size={17} /> Ask us on WhatsApp
            </a>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
